import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createSuperAdminHsn,
  createSuperAdminHsnGroup,
  deleteSuperAdminHsn,
  deleteSuperAdminHsnGroup,
  getAllSuperAdminHsn,
  getAllSuperAdminHsnGroups,
  getSuperAdminHsn,
  getSuperAdminHsnGroup,
  updateSuperAdminHsn,
  updateSuperAdminHsnGroup,
} from "services/superAdminHsn";

const HSN_KEY = ["super-admin-hsn"];
const HSN_GROUP_KEY = ["super-admin-hsn-groups"];

export const useAllSuperAdminHsn = (search) =>
  useQuery({
    queryKey: [...HSN_KEY, search],
    queryFn: () => getAllSuperAdminHsn(search),
  });

export const useSuperAdminHsn = (id) =>
  useQuery({
    queryKey: [...HSN_KEY, id],
    queryFn: () => getSuperAdminHsn(id),
    enabled: !!id,
  });

export const useCreateSuperAdminHsn = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSuperAdminHsn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HSN_KEY }),
  });
};

export const useUpdateSuperAdminHsn = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateSuperAdminHsn(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: HSN_KEY });
      queryClient.invalidateQueries({ queryKey: [...HSN_KEY, id] });
    },
  });
};

export const useDeleteSuperAdminHsn = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteSuperAdminHsn,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HSN_KEY }),
  });
};

export const useAllSuperAdminHsnGroups = (search) =>
  useQuery({
    queryKey: [...HSN_GROUP_KEY, search],
    queryFn: () => getAllSuperAdminHsnGroups(search),
  });

export const useSuperAdminHsnGroup = (id) =>
  useQuery({
    queryKey: [...HSN_GROUP_KEY, id],
    queryFn: () => getSuperAdminHsnGroup(id),
    enabled: !!id,
  });

export const useCreateSuperAdminHsnGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createSuperAdminHsnGroup,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HSN_GROUP_KEY }),
  });
};

export const useUpdateSuperAdminHsnGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }) => updateSuperAdminHsnGroup(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: HSN_GROUP_KEY });
      queryClient.invalidateQueries({ queryKey: [...HSN_GROUP_KEY, id] });
    },
  });
};

export const useDeleteSuperAdminHsnGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteSuperAdminHsnGroup,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: HSN_GROUP_KEY }),
  });
};
